export default {
  mr1: {
    value: {
      tooltip: 'Aggregate value of all underlying properties in MogulREIT I, LLC based on appraisals dated within 6 months of the original acquisition by Realty Mogul, Co. or Realty Mogul Commercial Capital, or the acquisition price, as applicable, as of the date of the last public filing. Changes in property values may or may not affect the net asset value of the REIT, which invests in loans and other fixed income investments.',
    },
    investments: {
      tooltip: 'Total number of investments, as of date of last public filing.',
    },
    investors: {
      tooltip: 'Total number of unique investors.',
    },
  },
  mr2: {
    value: {
      tooltip: 'Aggregate value of all underlying properties in MogulREIT II, Inc. based on the most recent purchase price of each asset.',
    },
    investments: {
      tooltip: 'Total number of investments, as of date of last public filing.',
    },
    investors: {
      tooltip: 'Total number of unique investors.',
    },
  },
};
